import { skipToken } from '@apollo/client/react'
import { useCheckTokenForArgs } from 'src/utils/token'
import { baseApolloClient } from './client'
import type { GetMyMembershipQuery } from './generated/graphql'
import {
  CancelSubscriptionDocument,
  GetMyMembershipDocument,
  GetUserMembershipDocument,
  ResumeSubscriptionDocument,
} from './generated/graphql'
import {
  createFetchQueryHelper,
  createMutationHelper,
  createQueryHook,
  createRefetchQueryHelper,
  modifyQueryHook,
} from './utils'

const useGetMyMembership = modifyQueryHook(
  createQueryHook(GetMyMembershipDocument),
  {
    reduce: r => r?.me,
  },
)
export const useMyMembership = (
  options?: Parameters<typeof useGetMyMembership>[1],
) => {
  const input = useCheckTokenForArgs({})
  const res = useGetMyMembership(input ?? skipToken, options)
  return res
}
export const fetchGetMyMembership = createFetchQueryHelper(
  GetMyMembershipDocument,
)
export const refetchGetMyMembership = createRefetchQueryHelper(
  GetMyMembershipDocument,
)
export const updateGetMyMembership = (data: GetMyMembershipQuery) => {
  baseApolloClient.refetchQueries({
    updateCache: cache => {
      cache.updateQuery(
        {
          query: GetMyMembershipDocument,
        },
        () => data,
      )
    },
  })
}

export const useGetUserMembership = modifyQueryHook(
  createQueryHook(GetUserMembershipDocument),
  {
    transform: (userId: string) => ({ userId }),
    reduce: r => r?.user,
  },
)

export const [useCancelSubscription, executeCancelSubscription] =
  createMutationHelper(CancelSubscriptionDocument)

export const [useResumeSubscription, executeResumeSubscription] =
  createMutationHelper(ResumeSubscriptionDocument)
